import LogoSymbol from './LogoSymbol';

export default LogoSymbol;
